import { createApp } from 'vue'
import App from './App.vue'

const mountEl = document.querySelector('#leaderboard')

if (mountEl) {
    const props = {}

    createApp(App, props).mount('#leaderboard')
}
